import PropTypes from 'prop-types'
import React, { Component } from 'react'
import _ from 'lodash'
import classNames from 'classnames'
import I18n from '../lib/i18n'
import IconSearch from '../images/icon_search.svg'
import IconClear from '../images/icon_clear.svg'

class SearchBar extends Component {
  constructor(props) {
    super(props)
    this.input = null

    if (props.renderSearchButton && !props.onSearch) {
      throw new Error('onSearch is required when rendering search button')
    }

    this.state = {
      isFocused: false,
      searchTerm: '',
      value: this.props.value || ''
    }
  }

  componentDidMount() {
    if (this.props.autoFocus) {
      this.input.focus()
    }
  }

  componentDidUpdate(prevPops, prevState, snapShot) {
    if (prevPops.value !== this.props.value) {
      this.setState({ value: this.props.value })
    }
  }

  clearSearch = () => {
    this.setState({
      searchTerm: '',
      value: ''
    })

    this.input.focus()
    this.props.onClear()
  }
  toggleFocus = () => {
    this.setState({
      isFocused: !this.state.isFocused
    })
  }

  handleChange = (event) => {
    const { value } = event.target
    const searchTerm = value.toLowerCase().trim()
    const oldSearchTerm = _.clone(this.state.searchTerm)

    this.setState({
      value
    })

    if (searchTerm !== this.state.searchTerm) {
      this.setState({
        searchTerm
      })
      // dont send ajax call if user is deleting the search keyword char
      if (searchTerm.length < oldSearchTerm.length) return
      this.props.onChange(searchTerm)
    }
  }

  handleKeyDown = (event) => {
    switch (event.key) {
      case 'ArrowUp':
      case 'ArrowDown':
        event.preventDefault()
        break

      case 'Enter':
        this.handleSearch()
        break

      case 'Escape':
        this.handleEscape()
        break

      default:
        break
    }
  }

  handleFormSubmit = (event) => {
    event.preventDefault()
    this.handleSearch()
    return false
  }

  handleSearch = () => {
    const { searchTerm } = this.state

    this.props.onSearch(searchTerm)
    this.input.blur()
  }

  handleEscape = () => {
    this.setState({
      searchTerm: ''
    })

    this.input.blur()
    this.props.onClear()
  }

  render() {
    const { value } = this.state
    const { styles } = this.props
    const attributes = _.omit(this.props, Object.keys(SearchBar.propTypes))
    const renderClearButton = !_.isEmpty(value)

    return (
      <div
        className={styles.wrapper}
        ref={ref => this.container = ref}
      >
        <form action='./' onSubmit={this.handleFormSubmit}>
          <div
            className={classNames({
              [styles.field]: true,
              [styles.fieldFocused]: this.state.isFocused
            })}
          >
            <img className="icon-search" src={IconSearch} alt='' />
            <input
              type="text"
              {...attributes}
              className={[styles.input, renderClearButton ? 'search-input-pad-right' : null].join(' ')}
              ref={ref => this.input = ref}
              value={value}
              onChange={this.handleChange}
              onFocus={this.toggleFocus}
              onBlur={this.toggleFocus}
              onKeyDown={this.handleKeyDown}
              minLength={/\W/.test(value) ? 2 : 3}
            />
            {
              renderClearButton &&
                <img className="search-reset" src={IconClear} alt={I18n.t('searchbar.reset')} onClick={this.clearSearch} />
            }
          </div>
        </form>
      </div>
    )
  }
}

SearchBar.propTypes = {
  autoFocus: PropTypes.bool,
  delay: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string
  ]),
  onClear: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  onSearch: PropTypes.func,
  onSelection: PropTypes.func,
  renderClearButton: PropTypes.bool,
  renderSearchButton: PropTypes.bool,
  styles: PropTypes.object
}

SearchBar.defaultProps = {
  autoCapitalize: 'off',
  autoComplete: 'off',
  autoCorrect: 'off',
  autoFocus: false,
  delay: 0,
  maxLength: 100,
  placeholder: '',
  renderClearButton: false,
  renderSearchButton: false,
  styles: {
    wrapper: 'react-search-bar__wrapper',
    field: 'react-search-bar__field',
    focusedField: 'react-search-bar__field--focused',
    input: 'react-search-bar__input',
    clearButton: 'react-search-bar__clear',
    submitButton: 'react-search-bar__submit'
  }
}

export default SearchBar



// WEBPACK FOOTER //
// ./src/lib/SearchBar.js